import moment from 'moment';
import { getUnmaskedValue } from './MaskUtils';

const cpfsInvalidos = [
  '00000000000',
  '11111111111',
  '22222222222',
  '33333333333',
  '44444444444',
  '55555555555',
  '66666666666',
  '77777777777',
  '88888888888',
  '99999999999'
];
export const matchYT = (url: string = '') => url.match(/youtu(\.){0,1}be/);
export const matchMicrosoftStream = (url: string = '') =>
  url.match(/(.*microsoftstream.com)(\/embed){0,1}\/video/);
export const matchVimeo = (url: string = '') =>
  url.match(/.*vimeo.com(\/video\/{0,1}){0,1}/);

export const validaCPF = (cpf: string) => {
  cpf = getUnmaskedValue(cpf);
  if (cpf.length !== 11 || cpfsInvalidos.indexOf(cpf) > -1) return false;
  // PRIMEIRO DIGITO
  let primeiraSoma = 0;
  for (let i = 0; i < 9; i++) {
    primeiraSoma += (10 - i) * parseInt(cpf[i]);
  }
  let primeiroResto = (primeiraSoma * 10) % 11;
  if (primeiroResto >= 10) primeiroResto = 0;
  if (primeiroResto !== parseInt(cpf[9])) return false;
  // SEGUNDO DIGITO
  let segundaSoma = 0;
  for (let i = 0; i < 10; i++) {
    segundaSoma += (11 - i) * parseInt(cpf[i]);
  }
  let segundoResto = (segundaSoma * 10) % 11;
  if (segundoResto >= 10) segundoResto = 0;
  if (segundoResto !== parseInt(cpf[10])) return false;
  return true;
};

export const validaCNPJ = (value: string) => {
  const cnpj = getUnmaskedValue(value);
  if (cnpj.length !== 14) return false;
  // Primeiro Dígito
  const firstMod =
    [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2].reduce((soma, atual, index) => {
      return soma + atual * parseInt(cnpj[index]);
    }, 0) % 11;
  const firstDigit = firstMod < 2 ? 0 : 11 - firstMod;
  if (firstDigit !== parseInt(cnpj[12])) return false;
  // Segundo Dígito
  const secondMod =
    [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2].reduce((soma, atual, index) => {
      return soma + atual * parseInt(cnpj[index]);
    }, 0) % 11;
  const secondDigit = secondMod < 2 ? 0 : 11 - secondMod;
  if (secondDigit !== parseInt(cnpj[13])) return false;
  return true;
};

export const validaTelefone = (telefone: string) => {
  telefone = getUnmaskedValue(telefone);
  if (telefone.length < 10 || telefone.length > 11) {
    return false;
  }
  return true;
};

export const validaData = (data: string) => {
  if (!String(data).match(/\d{2}\/{1}\d{2}\/{1}\d{4}/)) return false;
  const mData = moment(data, 'DD/MM/YYYY');
  if (!mData.isValid()) return false;
  return true;
};

export const validaHora = (data: string) => {
  return String(data).match(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/);
};

export const validaDataNascimento = (data: string) => {
  if (!validaData(data)) return false;
  const hoje = moment(),
    mData = moment(data, 'DD/MM/YYYY');
  if (mData.isAfter(hoje)) return false;
  return true;
};

export const validaEmail = (email: string) => {
  // const repeticao = /(.*)(@)(.*)((\.\w{2,})+(.)*(\5)+)+(.*)/ig;
  const confereEmail =
    /^(\w)+((\.|_|-){1}(\w)+)*(@){1}(\w+)((\.|_|-){1}\w+)+$/gi;
  if (!String(email).match(confereEmail)) {
    return false;
  }
  return true;
};

export const validaURL = (url: string) => {
  const regex =
    /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gi;
  const match = url.match(regex);
  return match && match.length;
};

export const validaConta = (conta: string) => {
  const value = getUnmaskedValue(conta);
  return value && value.length >= 6 && value.length <= 15;
};

export const validaDominioVideos = (url: string) => {
  return matchYT(url) || matchMicrosoftStream(url) || matchVimeo(url);
};

export const allIsTrue = (validations: boolean[]) => {
  return (
    validations.filter((item) => typeof item === 'boolean' && item === true)
      .length === validations.length
  );
};

export const allIsFalse = (validations: boolean[]) => {
  return (
    validations.filter((item) => typeof item === 'boolean' && item === false)
      .length === validations.length
  );
};

export const firstDateIsBefore = (firstDate: string, secondDate: string) => {
  const fd = moment(firstDate, 'DD/MM/YYYY');
  const sd = moment(secondDate, 'DD/MM/YYYY');
  return (
    secondDate &&
    secondDate.length &&
    validaData(firstDate) &&
    firstDate &&
    validaData(secondDate) &&
    firstDate.length &&
    fd.isBefore(sd)
  );
};

export const requiredIsValid = (value: any, messageError: string) => {
  if (
    typeof value === 'number' ||
    (typeof value === 'string' && value.trim().length > 0)
  ) {
    return {
      error: false
    };
  } else if (typeof value === 'object') {
    return {
      error: Array.isArray(value) ? !value || !value.length : !value,
      helperText: messageError
    };
  }
  return {
    error: true,
    helperText: messageError
  };
};

export const DEFAULT_VALIDATION_MODEL = (error = false, helperText = '') => {
  return {
    error,
    helperText
  };
};

export type validationType = {
  error: boolean;
  helperText?: string;
};

export const DEFAULT_VALID = DEFAULT_VALIDATION_MODEL(false, '');
